/*
 * Copyright (c) 2019. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import { Theme } from "@mui/material";

const globalStyles = (theme: Theme) => ({
  html: {
    height: "100%",
  },
  body: {
    color: theme.palette.text.primary,
    fontFamily: ["Roboto", "Arial", "Helvetica", "sans-serif"].join(","),
    fontSize: "1rem",
    fontWeight: 300,
    lineHeight: "1.5",
    height: "100%",
  },
  "#root": {
    height: "100%",
  },
  a: {
    color: theme.palette.primary.main,
    textDecoration: "none",
  },
  strong: {
    fontWeight: 500,
  },
});

export default globalStyles;
